import useCurrentUser from 'hooks/useCurrentUser';
import { isPermitted } from 'util/PermissionsMixin';
import useLicenseValidityForSubject from 'license/hooks/useLicenseValidityForSubject';
import { LICENSE_SUBJECTS } from 'license/constants';

const useCollectionViewCondition = () => {
  const {
    data: { valid: isValidLicense },
    isInitialLoading: isLoadingLicense,
  } = useLicenseValidityForSubject(LICENSE_SUBJECTS.enterprise);
  const currentUser = useCurrentUser();

  if (isLoadingLicense) {
    return false;
  }

  return isValidLicense && isPermitted(currentUser.permissions, 'collections:read');
};

export default useCollectionViewCondition;
